import { isEmpty } from 'underscore';
import unescapedText from 'I18n/utils/unescapedText';
import { createSearchRegExp, hasSearchMatch } from 'ContentComponents/components/cmv2/utils/generic';
import { DEFAULT_GOOGLE_FONT_VARIANT_FALLBACK_ORDER } from 'ContentUtils/constants/Fonts';
export const combineFonts = (fontOptions, hasMore = false, input = '') => {
  const {
    googleFontOptions,
    systemFonts,
    customFontOptions = []
  } = fontOptions;
  const searchRegExp = createSearchRegExp(input);
  const combinedSystemAndCustomFonts = [...systemFonts, ...customFontOptions];
  const combinedSystemAndCustomFontsFiltered = combinedSystemAndCustomFonts.filter(font => {
    return hasSearchMatch(searchRegExp, font.text);
  });
  let systemIndex = 0;
  let fontList = [];

  // starts font list if first alphabetical option is a system or custom font
  while (!isEmpty(googleFontOptions) && combinedSystemAndCustomFontsFiltered[systemIndex] && combinedSystemAndCustomFontsFiltered[systemIndex].text < googleFontOptions[0].text) {
    fontList.push(combinedSystemAndCustomFontsFiltered[systemIndex]);
    systemIndex++;
  }

  // alphabetically add in system & custom fonts to the google font list
  googleFontOptions.reduce((combinedFontList, fontOption, index) => {
    const systemOrCustomFont = combinedSystemAndCustomFontsFiltered[systemIndex];
    const previousFont = googleFontOptions[index - 1];
    if (systemOrCustomFont && systemOrCustomFont.text < fontOption.text) {
      if (previousFont && systemOrCustomFont.text > previousFont.text) {
        combinedFontList.push(systemOrCustomFont);
        systemIndex++;
      }
      if (!previousFont) {
        combinedFontList.push(systemOrCustomFont);
        systemIndex++;
      }
    }
    combinedFontList.push(fontOption);
    return combinedFontList;
  }, fontList);

  // finishes font list if last alphabetical option is a system or custom font
  if (!hasMore && combinedSystemAndCustomFontsFiltered.length) {
    fontList = fontList.concat(combinedSystemAndCustomFontsFiltered.slice(systemIndex));
  }
  return fontList;
};
const i18nKey = key => `ContentComponents.cmv2.fields.font.${key}`;
export const formatVariant = variant => {
  const weight = parseInt(variant, 10) || 400;
  let variantText = unescapedText(i18nKey(`weights.${weight}`));
  if (variant.includes('italic')) {
    variantText = unescapedText(i18nKey('weights.italic'), {
      weight: variantText
    });
  }
  return variantText;
};
export const getVariantStyles = variant => {
  const styles = {
    fontWeight: parseInt(variant, 10) || 400
  };
  if (variant.includes('italic')) styles.fontStyle = 'italic';
  return styles;
};
export const getDefaultVariant = (variants = []) => {
  if (!variants.length) return '';
  const stringVariants = typeof variants[0] === 'object' ? variants.map(variant => variant.name) : variants;
  const variantsMap = stringVariants.reduce((map, variant) => {
    map[variant] = variant;
    return map;
  }, {});
  for (const variant of DEFAULT_GOOGLE_FONT_VARIANT_FALLBACK_ORDER) {
    if (variantsMap[variant]) return variant;
  }
  return stringVariants[0];
};
const fontsCache = {};
const variantsCache = {};
export const loadFontStylesheet = (family, variants) => {
  if (!family) {
    return;
  }
  const googleFontUrl = `https://fonts.googleapis.com/css2?family=${family.replace(/\s/g, '+')}`;
  let weights = '';
  if (variants && !variantsCache[family]) {
    variantsCache[family] = family;
    weights = `:wght@${variants.filter(variant => !variant.includes('italic')).map(variant => parseInt(variant, 10) || 400).join(';')}`;
  }
  if (fontsCache[family]) {
    // The variants tend to load later, so this adds in the weights after
    // the font stylesheet was already added
    if (weights) {
      const linkEl = document.querySelector(`link[href^="${googleFontUrl}"]`);
      linkEl.setAttribute('href', `${googleFontUrl}${weights}`);
    }
    return;
  }
  fontsCache[family] = family;
  const linkEl = document.createElement('link');
  linkEl.setAttribute('href', `${googleFontUrl}${weights}`);
  linkEl.setAttribute('rel', 'stylesheet');
  document.getElementsByTagName('head')[0].appendChild(linkEl);
};